/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnumItem
 */
export interface EnumItem {
    /**
     * 编码
     * @type {number}
     * @memberof EnumItem
     */
    code?: number;
    /**
     * 枚举标识名
     * @type {string}
     * @memberof EnumItem
     */
    enumName?: string;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof EnumItem
     */
    name?: string;
}

/**
 * Check if a given object implements the EnumItem interface.
 */
export function instanceOfEnumItem(value: object): value is EnumItem {
    return true;
}

export function EnumItemFromJSON(json: any): EnumItem {
    return EnumItemFromJSONTyped(json, false);
}

export function EnumItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumItem {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'enumName': json['enumName'] == null ? undefined : json['enumName'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function EnumItemToJSON(json: any): EnumItem {
    return EnumItemToJSONTyped(json, false);
}

export function EnumItemToJSONTyped(value?: EnumItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'enumName': value['enumName'],
        'name': value['name'],
    };
}

